import styled from 'styled-components';
import DefaultModal from 'components/shared/Modal';

// Modal styling
export const Modal = styled(DefaultModal)`
  ._modalContainer {
    padding: 0;
    max-width: 920px;
    width: 100%;
    height: 100%;
    max-height: 610px;
  }
`;

// Container styling
export const Container = styled.div`
  width: 100%;
  max-width: auto;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: #fff;
  padding: 20px 32px 10px 32px;

  img {
    width: 100%;
    height: auto;
    object-fit: cover;
    margin-bottom: 20px;
  }

  h1 {
    font-size: 24px;
    color: ${({ theme }) => theme.font.color.primary};
    font-family: Arial, Helvetica, sans-serif;
    margin-bottom: 15px;
  }

  hr {
    height: 1px;
    background-color: #808285;
    margin-bottom: 35px;
  }
`;

// Form styling
export const Form = styled.form`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

// Button styling
export const Button = styled.button`
  margin-top: 40px;
  width: 265px;
  height: 36px;
  background: ${({ theme }) => theme.font.color.primary};
  color: #fff;
  border: none;
  font-size: 16px;
  font-weight: bold;

  &:hover {
    transform: scale(1.1);
  }
`;

// ActionsWrapper styling
export const ActionsWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  width: 100%;

  @media screen and (max-width: 680px) {
    flex-direction: column;
  }
  `;